import { render, staticRenderFns } from "./CPDueDiligenceAccountHolderDetails.vue?vue&type=template&id=5c041edf&scoped=true&"
import script from "./CPDueDiligenceAccountHolderDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceAccountHolderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceAccountHolderDetails.vue?vue&type=style&index=0&id=5c041edf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c041edf",
  null
  
)

export default component.exports